import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PropositionService } from '@arkius/shared-api';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs';
import { ThankYouBoostModalComponent } from '../thank-you-boost-modal/thank-you-boost-modal.component';

@Component({
  selector: 'ark-lib-boost-modal',
  templateUrl: './boost-modal.component.html',
  styleUrl: './boost-modal.component.css',
})
export class BoostModalComponent {
  @Input() id!: number;
  value: any;
  form: FormGroup = new FormGroup({
    value: new FormControl(null),
  });

  get errorText() {
    if (this.form.get('value') && this.form.get('value')?.errors) {
      const asds: any =
        this.form.get('value') && this.form.get('value')?.errors;
      return asds.failed;
    }
  }
  constructor(
    private modalCtrl: ModalController,
    private propositionService: PropositionService,
  ) {}
  boost() {
    this.form.controls['value'].setErrors(null);
    this.propositionService
      .apiV5PropositionIdBoostPost(this.id, { Budget: this.form.value.value })
      .pipe(take(1))
      .subscribe(
        async () => { 
          this.modalCtrl.dismiss(this.value, 'confirm');
  
          const thankYouBoostModal = await this.modalCtrl.create({
            component: ThankYouBoostModalComponent,
          });
         
          const modalElement = thankYouBoostModal.shadowRoot?.querySelector(
            '.modal-wrapper',
          ) as HTMLElement;
          if (modalElement) {
            modalElement.style.width = '90%';
            modalElement.style.borderRadius = '8px';
          }

          await thankYouBoostModal.present();
        },
        (err) => {
          this.form.controls['value'].setErrors({
            failed: 'There was an error. Try again later.',
          });
        },
      );
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
